import { render, staticRenderFns } from "./InfoPage.vue?vue&type=template&id=5321a493"
import script from "./InfoPage.vue?vue&type=script&lang=js"
export * from "./InfoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports